<style lang="scss">
.field {
    margin-bottom: 10px;
}

.layout {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

form {
    width: 400px;
}
</style>
<script lang="ts">
import { auth } from '../store/auth';
import Input from './Input.svelte';
import Button from './Button.svelte';

let username = '';
let password = '';

function onSubmit() {
    if (username && password) {
        auth.login(username, password);
    }
}
</script>
<div class="layout">
    <form action="/api/login" on:submit|preventDefault={onSubmit}>
        <div class="field">
            <Input name="username" autocomplete="username" bind:value={username}>Логин</Input>
        </div>
        <div class="field">
            <Input name="password" type="password" autocomplete="current-password" bind:value={password}>Пароль</Input>
        </div>
        {#if $auth.error}
            <div class="error">{ $auth.error.message }</div>
        {/if}
        <div class="field">
            <Button role="primary" disabled={$auth.loading}>Войти</Button>
        </div>
    </form>
</div>
